import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		islogin: false,
		username: '用户名',
		isvip: 0
	},
	mutations: {
		ISLOGIN(state, query) {
			state.islogin = query
		},
		USERNAME(state, query) {
			state.username = query
		},
		ISVIP(state, query){
			state.isvip = query
		}
	},
	actions: {},
	modules: {}
})
